import $ from 'jquery';
import { getState } from '~src/state';

export const addProvinoFormatsToExportMenu = () => {
  const projectType = getState('selected.tipo');
  $('#export-selector-provino-formats').hide();
  $('#provino-preview-col').hide();

  const formatiProvino = [
    {
      id: 'a4V',
      text: 'A4 Verticale',
      width: 210,
      height: 297,
      orientation: 'p',
    },
    {
      id: 'a4O',
      text: 'A4 Orizzontale',
      width: 297,
      height: 210,
      orientation: 'l',
    },
    {
      id: 'a3V',
      text: 'A3 Verticale',
      width: 297,
      height: 420,
      orientation: 'p',
    },
    {
      id: 'a3O',
      text: 'A3 Orizzontale',
      width: 420,
      height: 297,
      orientation: 'l',
    },
    {
      id: 'a5-verticale',
      text: 'A5 Verticale',
      width: 148,
      height: 210,
      orientation: 'p',
    },
    {
      id: 'a5-orizzontale',
      text: 'A5 Orizzontale',
      width: 210,
      height: 148,
      orientation: 'l',
    },
    {
      id: '48x32',
      text: '32 x 48 Verticale',
      width: 320,
      height: 480,
      orientation: 'p',
    },
    {
      id: '32x48',
      text: '32 x 48 Orizzontale',
      width: 480,
      height: 320,
      orientation: 'l',
    },
    {
      id: 'card',
      text: 'CARD',
      width: 55,
      height: 85,
      orientation: 'p',
      disabled: false,
    },
    {
      id: 'ricordino-153x313',
      text: 'CP 5000',
      width: 153,
      height: 313.5,
      orientation: 'p',
      disabled: false,
    },
    {
      // custom layout, handled in customLayouts/auto-cut-cc-150.js
      id: 'auto-cut-cc-150',
      text: 'Auto Cut CC-150',
      width: 297,
      height: 210,
      orientation: 'l',
      allowUserToManageMargins: false,
    },
    {
      // custom layout, handled in customLayouts/auto-cut-cc-150-10UP-landscape.js
      id: 'auto-cut-cc-150-10UP-landscape',
      text: 'Auto Cut CC-150 10 UP (Orizzontale)',
      width: 297,
      height: 210,
      orientation: 'l',
      allowUserToManageMargins: false,
    },
    {
      // custom layout, handled in customLayouts/ricordino-57x88.js
      id: 'ricordino-57x88',
      text: '57 x 88 mm',
      width: 297,
      height: 210,
      orientation: 'l',
      disabled: false,
      allowUserToManageMargins: false,
    },
    {
      // custom layout, handled in customLayouts/ricordino-130x180.js
      id: 'ricordino-130x180',
      text: '130 x 180 mm',
      width: 130,
      height: 180,
      orientation: 'p',
      disabled: false,
      allowUserToManageMargins: false,
    },
    {
      id: 'ricordino-150x308',
      text: '150 x 308 mm',
      width: 150,
      height: 308,
      orientation: 'p',
      disabled: false,
    },
    {
      id: 'ricordino-203x303',
      text: '203 x 303 mm',
      width: 203,
      height: 303,
      orientation: 'p',
      disabled: false,
    },
    {
      id: 'ricordino-154x103',
      text: '154 x 103 mm',
      width: 154,
      height: 103,
      orientation: 'l',
      disabled: false,
    },
    {
      id: 'ricordino-148x100',
      text: '148 x 100 mm',
      width: 148,
      height: 100,
      orientation: 'l',
      disabled: false,
    },
    {
      // custom layout, handled in customLayouts/ricordino-148x100-d500-d1000.js
      id: 'ricordino-148x100-d500-d1000',
      text: '148 x 100 mm (D500-D1000)',
      width: 148,
      height: 100,
      orientation: 'l',
      disabled: false,
      allowUserToManageMargins: false,
    },
    {
      id: 'ricordino-150x100',
      text: '150 x 100 mm',
      width: 150,
      height: 100,
      orientation: 'l',
      disabled: false,
    },
  ];

  if (projectType.griglia_provino === true) {
    $('#navbar-submenu-export-provino-output').select2({
      data: formatiProvino,
      tags: false,
      width: '100%',
      theme: 'bootstrap4',
      placeholder: 'Seleziona un formato',
    });
    $('#export-selector-provino-formats').show();
    $('#provino-preview-col').show();
    $('#navbar-submenu-export').addClass('navbar-submenu-two-columns');
    $('#export').text('Scarica Pagine Selezionate');
  } else {
    $('#export-selector-provino-formats').hide();
    $('#provino-preview-col').hide();
  }
};
